import * as types from "../../mutation-types";
import dashboard from "./dashboard";
import domain from "./domain";
import order from "./order";
import upgrade from "./upgrade";
import auth from "./auth";
import networking from "./networking";
import invoices from "./invoices";

const state = {
  items: [dashboard, domain, order, upgrade, networking, auth, invoices],
};

const mutations = {
  [types.TOGGLE_EXPAND_MENU_ITEM](state, payload) {
    let menuItem = payload.menuItem;
    let expand = payload.expand;
    if (menuItem.children && menuItem.meta) {
      menuItem.meta.expanded = expand;
    }
  },
};

const actions = {
  toggleExpandMenuItem({ commit }, payload) {
    commit(types.TOGGLE_EXPAND_MENU_ITEM, payload);
  },
};

export default {
  state,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/menu/index.js